import * as React from 'react';
import { useState } from 'react';
import { useSelector } from 'react-redux';
import { Button, Menu, MenuItem, Divider } from '@mui/material';
import { styled } from '@mui/material/styles';
import AccountCircleIcon from '@mui/icons-material/AccountCircle';
import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import SettingsIcon from '@mui/icons-material/Settings';
import CreditCardIcon from '@mui/icons-material/CreditCard';
import LogoutIcon from '@mui/icons-material/Logout';
import PersonIcon from '@mui/icons-material/Person';
import ReferIcon from '@mui/icons-material/GroupAdd';
import { useNavigate } from 'react-router-dom';
import {
  ROOT,
  LOGIN,
  SIGNUP,
  AUTHROOT,
  PROFILE,
  SUBSCRIPTION,
  BILLING,
  LTVLIBHOME,
  REFER,
} from '../../routes/CONSTANTS';
import {
  selectIsLoggedIn,
  selectUserFirstName,
  selectUserLastName,
} from '../auth/UserSlice';
import { handleLogout } from '../auth/AuthService';

const StyledMenu = styled((props) => (
  <Menu
    anchorOrigin={{
      vertical: 'bottom',
      horizontal: 'right',
    }}
    transformOrigin={{
      vertical: 'top',
      horizontal: 'right',
    }}
    {...props}
  />
))(({ theme }) => ({
  '& .MuiPaper-root': {
    borderRadius: 6,
    minWidth: 200,
  },
}));

export default function DesktopNav() {
  const buttonLeftMargin = 10;
  let navigate = useNavigate();
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };
  const loggedIn = useSelector(selectIsLoggedIn);
  const userFirstName = useSelector(selectUserFirstName);
  const userLastName = useSelector(selectUserLastName);

  return (
    <>
      {loggedIn ? (
        <>
          <Button
            id='auth-home-button'
            onClick={() => {
              navigate(AUTHROOT);
            }}
            style={{ marginLeft: buttonLeftMargin }}
          >
            MEMBER HOME
          </Button>
          <Button
            id='library-button'
            onClick={() => {
              navigate(LTVLIBHOME);
            }}
            style={{ marginLeft: buttonLeftMargin }}
          >
            LINKTIVITY LIBRARY
          </Button>
          <Button
            id='user-button'
            aria-controls={open ? 'basic-menu' : undefined}
            aria-haspopup='true'
            aria-expanded={open ? 'true' : undefined}
            onClick={handleClick}
            style={{ marginLeft: buttonLeftMargin }}
          >
            <AccountCircleIcon style={{ marginRight: '5' }} />
            {userFirstName + ' ' + userLastName}
            <KeyboardArrowDownIcon />
          </Button>
          <StyledMenu
            id='user-menu'
            anchorEl={anchorEl}
            open={open}
            onClose={handleClose}
            MenuListProps={{
              'aria-labelledby': 'user-button',
            }}
          >
            <MenuItem
              onClick={() => {
                navigate(PROFILE);
                handleClose();
              }}
            >
              <PersonIcon style={{ marginRight: '10' }} />
              Profile
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigate(SUBSCRIPTION);
                handleClose();
              }}
            >
              <SettingsIcon style={{ marginRight: '10' }} />
              Subscription
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigate(BILLING);
                handleClose();
              }}
            >
              <CreditCardIcon style={{ marginRight: '10' }} />
              Billing
            </MenuItem>
            <MenuItem
              onClick={() => {
                navigate(REFER);
                handleClose();
              }}
            >
              <ReferIcon style={{ marginRight: '10' }} />
              Refer a Friend
            </MenuItem>
            <Divider sx={{ my: 0.5 }} />
            <MenuItem
              onClick={() => {
                handleLogout();
                navigate(ROOT);
                handleClose();
              }}
            >
              <LogoutIcon style={{ marginRight: '10' }} />
              Logout
            </MenuItem>
          </StyledMenu>
        </>
      ) : (
        <>
          <Button
            id='library-preview-button'
            onClick={() => {
              navigate(LTVLIBHOME);
            }}
            style={{ marginLeft: buttonLeftMargin }}
          >
            LIBRARY PREVIEW
          </Button>
          <Button
            id='sign-up-button'
            onClick={() => {
              navigate(SIGNUP);
            }}
            style={{ marginLeft: buttonLeftMargin }}
          >
            SIGN UP
          </Button>
          <Button
            id='login-button'
            onClick={() => {
              navigate(LOGIN);
            }}
            style={{ marginLeft: buttonLeftMargin }}
          >
            MEMBER LOGIN
          </Button>
        </>
      )}
    </>
  );
}
